import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=44ffeb46"
import script from "./UserAvatar.vue?vue&type=script&lang=js"
export * from "./UserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ffeb46')) {
      api.createRecord('44ffeb46', component.options)
    } else {
      api.reload('44ffeb46', component.options)
    }
    module.hot.accept("./UserAvatar.vue?vue&type=template&id=44ffeb46", function () {
      api.rerender('44ffeb46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/UserAvatar.vue"
export default component.exports